import { useWorkspace } from '../contexts/WorkspaceContext';

export interface UseGoogleDriveIntegrationResult {
  /** True once an active google-drive credential is found. */
  connected: boolean;
  /** Credential uuid to pass to picker-config / from-drive routes (null when not connected). */
  integrationUuid: string | null;
  /** Connected Google account email, for the "from {email}'s Drive" hint (null when unknown). */
  accountEmail: string | null;
  isLoading: boolean;
}

/**
 * useGoogleDriveIntegration - read the workspace's connected Google Drive credential.
 *
 * The lookup itself lives in WorkspaceContext, which resolves it ONCE on workspace load and shares
 * it app-wide (see `googleDriveIntegration` there). Reading the already-resolved status here - vs.
 * a per-mount fetch - means a Drive affordance renders together with the card that uses it, instead
 * of popping in after a late fetch. Workspace switches reload the page, so the status is always for
 * the current workspace.
 *
 * Returns connected=false (rather than throwing) when no active credential exists, so callers can
 * simply hide the Drive affordance.
 */
export function useGoogleDriveIntegration(): UseGoogleDriveIntegrationResult {
  return useWorkspace().googleDriveIntegration;
}
